import { render, staticRenderFns } from "./LegChoose.vue?vue&type=template&id=6ee4a3fc"
import script from "./LegChoose.vue?vue&type=script&lang=ts"
export * from "./LegChoose.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports